import { BASE_URL, MOBILE_BASE_URL } from "../api_const"

export const URL_USER_ENGAGEMENT_ACTIONS = BASE_URL + "/user-engagement/campaign/actions"